import React, { useCallback } from 'react';
import { pick, prop } from 'ramda';
import { dispatcher } from 'dispatcher';
import { Icon } from 'js/components/common/Icon';
import { usePageSelector, useUserSelector } from 'js/store/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';
import { LogoMobile } from '../Logo';
import * as hooks from 'js/components/main/DefaultHeader/hooks';
import { MyBalance } from '../MyBalance';

import style from './MobileHeader.scss';
import { Inbox } from '../Inbox';
import { MyBonuses } from '../MyBonuses';

export const MobileHeader: React.FC = () => {
    const translate = useComponentTranslations();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const { overrideMenu, menuWcId } = usePageSelector(pick(['overrideMenu', 'menuWcId']));
    const hideSideMenuIcon = overrideMenu && !menuWcId;
    const openSideMenu = useCallback(() => dispatcher.dispatch('menu:action:open'), []);
    const { isShowBackButton } = hooks.useBackButton();

    return (
        <>
            {isLoggedIn ? (
                <div className={style.userHeader}>
                    <div className={style.menuContainer} onClick={openSideMenu}>
                        {!hideSideMenuIcon && !isShowBackButton && (
                            <LogoMobile/>
                        )}
                        <span className={style.swissText}>{translate('header.menu')}</span>
                    </div>
                    <div className={style.infoContainer}>
                        <MyBonuses/>
                        <Inbox/>
                        <MyBalance/>
                    </div>
                </div>
            ) : (
                <div className={style.guestHeader}>
                    <div className={style.menuItem}>
                        {!hideSideMenuIcon && !isShowBackButton && (
                            <Icon
                                type="sideMenu"
                                onClick={openSideMenu}
                                className={`${style.menu} cms-icon-side-menu`}
                                aria-label={translate('header.sideMenu.aria-label')}
                            />

                        )}
                    </div>
                    <div className={style.menuItem}>
                        <LogoMobile/>
                    </div>
                    <div className={style.menuItem}>
                        <div
                            className={`${style.loginBtn} btn_action_login` }
                            onClick={onLoginButtonClick}
                            aria-label={translate('login.button.loginHeader')}>
                            <span className="shine-animation"></span>
                            {translate('login.button.loginHeader')}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
